import { initUnauthorizedState } from './initState/initAuthState';
import { LogoutReason, PERMISSIONS } from '@shared/constants';
import { UserRoleTypes } from '@shared/constants/UserRoleTypes';
import * as AuthActions from '@shared/redux/actions/auth-actions';

export interface AuthorizedState {
  isAuthenticated: true;
  loginWindowStep: 'login' | 'secondFactor';
  phone: string;
  userName: string;
  userId: string;
  user_self_permissions: UserRoleTypes;
  user_other_permissions: PERMISSIONS;
  user_other_orgmanager_permissions: PERMISSIONS;
  org_settings_permissions: PERMISSIONS;
  organisation_permissions: PERMISSIONS;
  organisation_other_permissions: PERMISSIONS;
  med_settings_permissions: PERMISSIONS;
  sd_card_upload_permissions: PERMISSIONS;
  patient_permissions: PERMISSIONS;
  device_settings: PERMISSIONS;
  download_firmware_permissions: PERMISSIONS;
  pic_permissions: PERMISSIONS;
  preregister_device: PERMISSIONS;
}

export interface UnauthorizedState {
  isAuthenticated: false;
  lastLogoutReason: LogoutReason;
}

export type AuthState = AuthorizedState | UnauthorizedState;

export default function auth(state: AuthState = initUnauthorizedState, action: AuthActions.AuthActions): AuthState {
  switch (action.type) {
    case AuthActions.UPDATE_USER_DATA: {
      if (action.payload.isAuthenticated) {
        return {
          ...state,
          ...action.payload,
        };
      } else {
        return {
          ...action.payload,
          lastLogoutReason: state.isAuthenticated ? LogoutReason.Unknown : state.lastLogoutReason,
        };
      }
    }

    case AuthActions.LOGOUT_SUCCESS:
      return {
        ...initUnauthorizedState,
        lastLogoutReason: action.payload.reason,
      };

    default:
      return state;
  }
}
